import { render, staticRenderFns } from "./UniversalVerify.vue?vue&type=template&id=704fe8e8&scoped=true"
import script from "./UniversalVerify.vue?vue&type=script&lang=js"
export * from "./UniversalVerify.vue?vue&type=script&lang=js"
import style0 from "./UniversalVerify.vue?vue&type=style&index=0&id=704fe8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fe8e8",
  null
  
)

export default component.exports